import * as THREE from "three";
import type { Vec3 } from "@mmo/shared";

const LIFE_MS = 120;
const POOL_SIZE = 32;

type Slot = {
  line: THREE.Line;
  mat: THREE.LineBasicMaterial;
  positions: Float32Array;
  attr: THREE.BufferAttribute;
  active: boolean;
  bornAt: number;
};

export class Tracers {
  private scene: THREE.Scene;
  private pool: Slot[] = [];

  constructor(scene: THREE.Scene) {
    this.scene = scene;
    for (let i = 0; i < POOL_SIZE; i++) {
      const positions = new Float32Array(6);
      const attr = new THREE.BufferAttribute(positions, 3);
      attr.setUsage(THREE.DynamicDrawUsage);
      const geo = new THREE.BufferGeometry();
      geo.setAttribute("position", attr);
      const mat = new THREE.LineBasicMaterial({ transparent: true, opacity: 0 });
      const line = new THREE.Line(geo, mat);
      line.visible = false;
      line.frustumCulled = false;
      this.scene.add(line);
      this.pool.push({ line, mat, positions, attr, active: false, bornAt: 0 });
    }
  }

  add(origin: Vec3, end: Vec3, hit: boolean) {
    const slot = this.pool.find((s) => !s.active) ?? this.pool[0];
    slot.positions[0] = origin.x; slot.positions[1] = origin.y; slot.positions[2] = origin.z;
    slot.positions[3] = end.x;    slot.positions[4] = end.y;    slot.positions[5] = end.z;
    slot.attr.needsUpdate = true;
    slot.mat.color.setHex(hit ? 0xff5555 : 0xffee66);
    slot.mat.opacity = 1;
    slot.line.visible = true;
    slot.active = true;
    slot.bornAt = performance.now();
  }

  update(now: number) {
    for (const slot of this.pool) {
      if (!slot.active) continue;
      const age = now - slot.bornAt;
      if (age >= LIFE_MS) {
        slot.active = false;
        slot.line.visible = false;
        slot.mat.opacity = 0;
      } else {
        slot.mat.opacity = 1 - age / LIFE_MS;
      }
    }
  }
}
